import isEmpty from 'lodash/isEmpty';
import isString from 'lodash/isString';
import isArray from 'lodash/isArray';
import * as apiResponseMessages from '../api-response-messages';

export const UNAUTHORIZED_STATUS_CODE = 401;
const TOO_MANY_REQUESTS_STATUS_CODE = 429;
export function getServerErrorMessages(response) {
    const errorMessage = response.errorMessage;
    if (isEmpty(response) || isEmpty(errorMessage)) {
        return [apiResponseMessages.SERVER_ERROR_MESSAGE];
    }

    if (errorMessage.includes('Network error')) {
        return [apiResponseMessages.SERVER_ERROR_MESSAGE];
    }

    if (response.statusCode === UNAUTHORIZED_STATUS_CODE ||
        response.statusCode === TOO_MANY_REQUESTS_STATUS_CODE) {
        return [errorMessage];
    }

    if (isArray(errorMessage)) {
        return errorMessage;
    }

    if (isString(errorMessage) && !isTextJSON(errorMessage)) {
        return [errorMessage];
    }

    const parsedResponse = JSON.parse(errorMessage);

    if (isEmpty(parsedResponse) || isEmpty(parsedResponse.errors)) {
        return [apiResponseMessages.SERVER_ERROR_MESSAGE];
    }

    const allErrors = Object.values(parsedResponse.errors);

    return isEmpty(allErrors) ? [apiResponseMessages.SERVER_ERROR_MESSAGE] : allErrors;
}

function isTextJSON(text) {
    if (!isString(text)) {
        return false;
    }

    try {
        JSON.parse(text);
        return true;
    } catch (error) {
        return false;
    }
}
